<template>
  <layout-pondlogs headerType="card" containerType="card" class="culture-abw">
    <template slot="title">{{ $t("ABW_abw") }}</template>
    <template slot="header">
      <layout-toolbar>
        <er-single-day-picker
          :value="abwDate"
          value-format="yyyy-MM-dd"
          @change-prev-day="prevDayClick"
          @change-next-day="nextDayClick"
          @change-day="handlePresentDateChange"
        ></er-single-day-picker>
        <el-col :span="4.3">
          <er-input
            inputType="search"
            size="mini"
            v-model="searchPond"
            :placeholder="$t('Ponds_select_pond_name')"
            suffix-icon="el-icon-search"
          ></er-input>
        </el-col>
      </layout-toolbar>
    </template>
    <el-row slot="pondlogs-default-layout-main">
      <!-- populate table with ponds -->
      <er-data-tables
        v-loading="loading"
        :tableData="tableData"
        :key="$i18n.locale"
        :columns="tableColumns"
        type="white-header-table"
        uniqueId="abw-table"
        :action-column="false"
        ref="abwtable"
        :el-table-props="tableProps"
        :selectColumn="true"
        :pagination-slot="true"
        :sortMethodForColumns="sortMethodForColumns"
      >
        <template v-slot:selected_header="{ $index }">
          <el-checkbox
            :key="$index"
            :value="checkAll"
            :indeterminate="isIndeterminate"
            @change="handleSelectAll"
          ></el-checkbox>
        </template>
        <template v-slot:selected="{ row }">
          <el-checkbox v-model="row.data.selected"></el-checkbox>
        </template>
        <template v-slot:pond_name="{ row }">
          {{ row.data.pond_title }}
        </template>

        <template v-slot:last_abw="{ row }">
          {{ row.data.last_abw | numberWith2DigitPrecision }}
        </template>

        <template v-slot:last_abw_date="{ row }">
          {{
            row.data.last_abw_date === "--"
              ? "--"
              : $moment
                  .utc(row.data.last_abw_date)
                  .format($commonUtils.MOMENT_DATE_FORMAT_WITH_YEAR)
          }}
        </template>
        <!-- implementing the samples popover -->
        <template v-slot:samples="{ row }">
          <samples-table2
            :popover-data="row.data"
            :hasUpdatePermission="hasUpdatePermissions"
            @cancelled="handleSampleTablePopverCancel"
          ></samples-table2>
        </template>
        <template v-slot:abw_g="{ row }">
          <el-input-number
            :controls="false"
            :precision="2"
            :min="0"
            class="input_abw"
            size="mini"
            v-model="row.data.abw"
            @change="handleChangeInABW($event, row.data)"
          ></el-input-number>
        </template>
        <template v-slot:wg_g="{ row }">
          {{ row.data.weight_gain | numberWith2DigitPrecision }}
          <!-- calcWeightGain(scope.row) -->
        </template>
        <!-- need to implement the survival percentage -->
        <template v-slot:survival_per="{ row }">
          <el-input-number
            class="input_survival_per"
            :controls="false"
            :precision="0"
            size="mini"
            :max="100"
            :min="0"
            v-model="row.data.survival_percentage"
          ></el-input-number>
        </template>
        <el-row type="flex" slot="pagination" class="btns-container">
          <er-button
            btnType="save"
            :showIcon="true"
            :disabled="isReadOnly"
            :loading="loading"
            @click="saveSelectedABWDetails"
            :showLabel="true"
            size="mini"
          ></er-button>
          <er-button
            btnType="cancel"
            :showLabel="true"
            size="mini"
            :disabled="isReadOnly"
            @click="cancelSelectedABWDetails"
          ></er-button>
        </el-row>
      </er-data-tables>
      <span v-if="harvestedPonds.length > 0">
        <el-alert
          :title="
            `${$t('ABW_hrvst_completed_ponds_list')}: ${harvestedPonds.length}`
          "
          type="info"
          show-icon
          :closable="false"
        >
          <h4>{{ harvestedPonds.join(", ") }}</h4>
        </el-alert>
        <el-col>
          <el-row class="abbr-row">
            <h6 v-html="$t('ABW_abbr')"></h6>
          </el-row>
        </el-col>
      </span>
      <br />
    </el-row>
  </layout-pondlogs>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import samplesTable2 from "./samplesTable2";

export default {
  mixins: [errorHandlerMixin],
  props: ["permissions"],
  components: {
    samplesTable2
  },
  data: function() {
    return {
      currOpenedPopoverId: undefined,
      pondsInLocation: [],
      abwDate: "",
      abwObjects: {},
      loading: false,
      pondsHavingABW: [],
      searchPond: "",
      tableProps: {
        size: "small",
        defaultSort: {
          prop: "pond_title",
          order: "ascending"
        }
      },
      query: { limit: 1, page: 1, location_id: "" }
    };
  },
  watch: {
    "$i18n.locale": function(newLang, oldLang) {
      this.$moment.locale(newLang);
    }
  },
  filters: {
    numberWith2DigitPrecision(value) {
      if (!value) return 0;
      value = Number(value);
      return value.toFixed(2);
    }
  },
  computed: {
    ...mapGetters("pond", {
      getPonds: "getPonds",
      getMapPondidPond: "getMapPondidPond",
      getPondsObj: "getPondsObj",
      getPondIDsHavingABW: "getPondIDsHavingABW",
      getpondHavingABWWithAbwValues: "getpondHavingABWWithAbwValues"
    }),
    ...mapGetters("user", {
      getUserLocations: "getUserLocations",
      getCurrUserLocation: "getCurrUserLocation",
      getUserTimeZoneOffset: "getUserTimeZoneOffset",
      isReadOnly: "isReadOnly"
    }),
    checkAll: function() {
      return this.tableData.every(abwRecord => abwRecord.selected === true);
    },
    isIndeterminate: function() {
      return (
        this.tableData.some(abwRecord => abwRecord.selected === true) &&
        !this.checkAll
      );
    },
    hasUpdatePermissions() {
      return this.getUpdatePermissions.MANAGE_ABW;
    },
    getLocationId() {
      return this.getCurrUserLocation._id;
    },
    pickerOptions: function() {
      return {
        disabledDate: function(date) {
          return date.getTime() > Date.now();
        }
      };
    },
    sortMethodForColumns: function() {
      return {
        pond_title: this.$commonUtils.alphaNumericComparator
      };
    },
    getMomentObjForSelectedDate: function() {
      const momentISOString = this.$moment
        .utc(this.abwDate || -1, "YYYY-MM-DD")
        .toISOString();
      const userISOString = this.$commonUtils.castISOStringToUserTZ(
        momentISOString,
        this.getUserTimeZoneOffset
      );
      const momentObj = this.$moment(userISOString).utcOffset(
        this.getUserTimeZoneOffset
      );
      return this.$lodash.cloneDeep(momentObj);
    },
    filterPondHavingABW() {
      const selectedDate = this.getMomentObjForSelectedDate;
      return Object.values(this.getpondHavingABWWithAbwValues).reduce(
        (acc, value) => {
          const stockingDate = this.$moment(value.cultivation_date);
          if (stockingDate.isSameOrBefore(selectedDate, "days")) {
            acc.push(value);
          }
          return acc;
        },
        []
      );
    },
    tableColumns() {
      return {
        selected: {
          label: "",
          prop: "selected",
          width: "50px"
        },
        pond_name: {
          label: this.$t("Comn_pond_name"),
          prop: "pond_title",
          sortable: true
        },
        last_abw: {
          label: `${this.$t("ABW_last_abw")} (g)`,
          prop: "last_abw",
          sortable: true
        },
        last_abw_date: {
          label: this.$t("ABW_last_abw_date"),
          prop: "last_abw_date",
          sortable: true
        },
        samples: {
          label: this.$t("Comn_samples"),
          prop: "samples",
          nested: true,
          nestedColumns: {
            weight_g: {
              label: this.$t("Comn_weight_g"),
              prop: "weight_g"
            }
          }
        },
        abw_g: {
          label: this.$t("Comn_abw_g"),
          prop: "abw",
          sortable: true
        },
        wg_g: {
          label: this.$t("Comn_wg_g"),
          prop: "wg_g",
          sortable: true
        },
        survival_per: {
          label: this.$t("Comn_survival_percentage"),
          prop: "survival_per",
          sortable: true
        }
      };
    },
    harvestedPonds() {
      const ponds = this.getPonds;
      const pondsInHarvest = [];
      ponds.forEach(pond => {
        const dateDiff = this.$moment(`${this.abwDate}T00:00:00.000Z`).diff(
          pond.cultivation_date
        );
        if (pond.status === "INACTIVE" || dateDiff < 0) {
          if (this.getPondIDsHavingABW.indexOf(pond._id) > -1) {
            pondsInHarvest.push(pond);
          }
        }
      });
      return pondsInHarvest
        .map(pond => pond.title)
        .sort((a, b) => this.$commonUtils.alphaNumericComparator(a, b));
    },
    tableData() {
      return this.searchPond !== ""
        ? this.pondsHavingABW.filter(x =>
            x.pond_title.toLowerCase().includes(this.searchPond.toLowerCase())
          )
        : this.pondsHavingABW;
    },
    selectedABWRecords: function() {
      return this.tableData.filter(x => x.selected);
    }
  },
  async mounted() {
    this.initDate();
    await this.initComponent();
  },
  methods: {
    ...mapActions("pond", {
      fetchAllPonds: "fetchAllPonds",
      fetchABWSummary: "fetchABWSummary"
    }),
    initDate() {
      this.abwDate = this.$moment()
        .utcOffset(this.getUserTimeZoneOffset)
        .startOf("day")
        .format("YYYY-MM-DD");
    },
    handleOpenedPopover(openedPopoverPondId) {
      if (this.currOpenedPopoverId === undefined) {
        this.currOpenedPopoverId = openedPopoverPondId;
      } else if (this.currOpenedPopoverId !== openedPopoverPondId) {
        const foundIndex = this.pondsHavingABW
          .map(x => x.pond_id)
          .indexOf(openedPopoverPondId);
        const abwRec = this.pondsHavingABW[foundIndex];
        this.$set(abwRec, "isPopUpVisible", false);
        // this.pondsHavingABW.splice(this.currOpenedPopoverId, 1, abwRec);
        this.currOpenedPopoverId = openedPopoverPondId;
      }
    },
    async initComponent() {
      this.loading = true;
      try {
        this.pondsHavingABW = [];
        await Promise.all([
          this.fetchAllPonds({
            location_id: this.getCurrUserLocation._id,
            status: ["ACTIVE", "INACTIVE"],
            include: ["title", "status", "cultivation_date"],
            get_all: true
          }),
          this.fetchABWSummary({
            date: `${this.abwDate}T00:00:00.000Z`,
            location_id: this.getCurrUserLocation._id,
            get_all: true
          })
        ]);
        this.pondsHavingABW = this.filterPondHavingABW
          .filter(x => this.harvestedPonds.indexOf(x) === -1)
          .map(x => {
            x.isPopUpVisible = false;
            x.present_date = this.abwDate;
            x.pond_title = (
              this.getPondsObj[x.pond_id] || { title: "no title" }
            ).title;
            x.selected = false;
            return this.$lodash.cloneDeep(x);
          });
        (this.pondsHavingABW || []).forEach(abw => {
          this.calcWeightGain(abw, false);
        });
        this.pondsInLocation = this.getPonds;
        this.query.location_id = this.getCurrUserLocation._id;
        // await this.fetchABWValues(this.query);
      } catch (err) {
        console.error(err);
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    async prevDayClick(date) {
      this.abwDate = date;
      await this.initComponent();
    },
    async nextDayClick(date) {
      this.abwDate = date;
      await this.initComponent();
    },
    saveSelectedABWDetails: async function() {
      try {
        this.isEditable(this.permissions);
        this.loading = true;
        const errors = [];
        if (this.pondsHavingABW.length === 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                message: this.$t("Comn_no_records_found")
              }
            ]
          };
        }
        const payload = this.selectedABWRecords.map(
          ({
            pond_id,
            pond_title,
            present_date,
            abw,
            samples,
            survival_percentage
          }) => {
            const date = `${this.$moment
              .utc(present_date)
              .format("YYYY-MM-DD")}T00:00:00.000Z`;
            if (abw <= 0) {
              errors.push({
                message: `${pond_title} ${this.$tc(
                  "Comn_must_greater_than",
                  2,
                  { field: this.$t("ABW_abw"), threshold: 0 }
                )}`
              });
            }
            const aggAbw = samples.reduce(
              (acc, x) => {
                acc[0] += x.weight;
                acc[1] += x.no_of_shrimps;
                return acc;
              },
              [0, 0]
            );
            if (aggAbw[0] > 0 && aggAbw[1] > 0) {
              return { pond_id, date, abw, samples, survival_percentage };
            }
            return { pond_id, date, abw, survival_percentage };
          }
        );
        if (payload.length === 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: [
              {
                message: this.$t("Comn_select_atleast_item", {
                  item: this.$t("ABW_abw")
                })
              }
            ]
          };
        }
        if (errors.length > 0) {
          throw {
            type: "FAIL_TO_SAVE",
            errors: errors
          };
        }
        await this.$store.dispatch("pond/saveABWValues", payload);
        this.$notify({
          title: this.$t("Usrs_success_msg"),
          message: this.$t("Abw_created_success"),
          duration: 5000,
          type: "success"
        });
        await this.initComponent();
      } catch (error) {
        this.errorMessages(error, true);
      } finally {
        this.loading = false;
      }
    },
    cancelSelectedABWDetails: async function() {
      await this.initComponent();
    },
    updateFields: function(abwObj, event = "") {
      this.calcABW(abwObj);
      this.calcWeightGain(abwObj);
      if (event === "calculate") abwObj.isPopUpVisible = !abwObj.isPopUpVisible;
    },
    handleChangeInABW(changedABWValue, abwRecord) {
      abwRecord.modified = true;
      const agg = abwRecord.samples.reduce(
        (acc, x) => {
          if (!isFinite(+x.no_of_shrimps) || !isFinite(x.weight)) return acc;
          acc[0] += x.no_of_shrimps;
          acc[1] += x.weight;
          return acc;
        },
        [0, 0]
      );
      this.calcWeightGain(abwRecord);
      if (agg[0] === 0 && agg[1] === 0) return;
      abwRecord.samples.forEach(sample => {
        sample.abw = changedABWValue;
        sample.no_of_shrimps = sample.no_of_shrimps || 1;
        sample.weight = changedABWValue * sample.no_of_shrimps;
      });
    },
    calcABW: function(abwObj) {
      let totalWeight = 0;
      let totalSamples = 0;
      abwObj.samples.forEach(sample => {
        sample.abw = sample.weight / sample.no_of_shrimps;
        totalWeight += sample.weight;
        totalSamples += sample.no_of_shrimps;
      });
      if (totalWeight) {
        abwObj.abw = totalWeight / totalSamples;
      } else {
        abwObj.abw = 0;
      }
      return abwObj.abw;
    },
    calcWeightGain: function(abwObj, modified = true) {
      if (modified) {
        abwObj.modified = true;
      }
      if (abwObj.abw > 0) {
        abwObj.weight_gain = Number(
          (abwObj.abw - (abwObj.last_abw || 0)).toFixed(2)
        );
      } else {
        abwObj.weight_gain = 0;
      }

      return abwObj.weight_gain;
    },
    handlePresentDateChange: async function(date) {
      this.abwDate = date;
      await this.initComponent();
    },
    handleSampleTablePopverCancel(abwObj) {
      const foundIndex = this.pondsHavingABW
        .map(x => x.pond_id)
        .indexOf(abwObj.pond_id);
      this.pondsHavingABW.splice(foundIndex, 1, abwObj);
    },
    handleChangeInColumnSelection(selectedColumns) {
      const columnObj = selectedColumns.reduce((acc, curr) => {
        acc[curr] = this.tableColumns[curr];
        return acc;
      }, {});
      this.selectedHeaders = Object.assign({}, columnObj);
    },
    handleSelectAll(value) {
      this.tableData.forEach(abwRecord => {
        abwRecord.selected = value;
      });
    }
  }
};
</script>

<style lang="scss">
.abw-action-items {
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  justify-content: flex-start;
  // margin: 0px 10px 10px 10px;
  & > div:nth-child(n + 1) {
    margin-right: 10px;
  }
}

.culture-abw {
  h3 {
    font-weight: 700;
    font-size: 20px;
  }
  // .day-picker-container {
  //   @include responsiveProperty(width, 100px, 115px, 140px);
  // }
  .er-button.er-button--primary {
    border-radius: 12px;
    height: 27px;
    line-height: 0.5;
  }
  .er-data-tables .pagination-bar .el-pagination button.el-button--primary {
    background: #409eff;
    color: white;
    margin-left: 10rem;
    width: 80px;
  }

  .er-button.er-button--danger {
    border-radius: 12px;
    height: 27px;
    line-height: 0.5;
  }
  .er-data-tables .pagination-bar .el-pagination button.el-button--danger {
    background: #f56c6c;
    color: white;
    // margin-left: 10rem;
    width: 80px;
  }
  .day-picker-top {
    display: flex;

    .el-input--small .el-input__icon {
      line-height: 0px;
    }
    .el-input__icon {
      height: 88%;
    }
    .el-input__inner {
      border: 0px solid #dcdfe6 !important;
      padding-right: 0px;
      border-radius: 8px;
    }
    img {
      width: 11px;
      &:hover {
        cursor: pointer;
      }
    }
    .prev-day-icon {
      margin-left: 2px;
    }
    .next-day-icon {
      margin-left: 8px;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 100px;
    }
  }
  &.culture-abw-scroll {
    height: 100%;
  }
  .abbr-row {
    line-height: 3;
  }
  .culture-abw-scroll-view {
    padding-right: 10px;
  }
  .culture-abw-scroll-wrap {
    height: 100%;
    overflow-x: auto;
  }
  .input_survival_per,
  .input_abw {
    width: 80px;
    .el-input__inner {
      text-align: center;
    }
  }
  .el-pagination__sizes {
    .el-input__inner {
      height: 23px;
      line-height: 23px;
    }
  }
}
</style>
